<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        برامج محاسبية وإدارية (Desktop Applications)
                    </h2>
                    <p>
                        برامج الديسك توب التى تقدمها الشركة هى مجموعة مختلفة من النظم يتم وضعها بواسطة فريق العمل الخاص بالشركة بما يتناسب مع أعمال المشروع أو الشركة أو الهيئة أو الموسسة التى يتم وضع النظم اﻷلكترونية لها اعتمادا على وسائل التكنولوجيا الحديثة والتى تهدف الى تقليل الوقت والجهد والتكلفة التى تلزم ﻻنجاز اﻻعمال داخل المنظمة التى يتم التعامل معها .
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/desktop-image-1.png" alt="seo" />
            </div>
        </div>
    </div>
</section>